import { createMuiTheme } from '@material-ui/core/styles';
import { blue, purple } from '@material-ui/core/colors';

const theme = createMuiTheme({
  palette: {
    primary: blue,
    secondary: purple,
  },
  status: {
    danger: 'orange',
  },
  typography: {
    fontFamily: "'IBM Plex Sans', sans-serif",
    fontWeight: 400,
  },
});

export default theme;
